/* eslint-disable*/
/*
  Mock packages grant ONLY mock exams — never quizzes, questions, notes, videos,
  PDFs or the formula sheet (subscription-dataflow.md § "Mock packages").

  Callers that pass `examPlanData` (resp_exam.examPlan[0]) are the pages that must
  not open on a mock. That argument used to short-circuit every check to false
  whenever examPlan[0] was a mock — an ARBITRARY row (no ORDER BY, so effectively
  the lowest owned plan id). Monthly plans have higher ids than the mock plans, so
  a partner owning an FRM mock and a monthly subscription was always denied. For
  those callers mock levels (including the FRM Mock Unlimited on frm_1_2) are now
  skipped per level, which does not depend on order. Callers that do not pass
  examPlanData keep their previous behaviour. Same approach as Cfa1Subscription.js
  (D32).
*/
var arr = { "1": "frm", "2": "frm_2" };

/*
--------------------------------------------------------------------------
  FUNCTION TO CHECK SUBSCRIPTION FOR QUIZZES, QUESTIONS AND MOCK EXAMS
--------------------------------------------------------------------------
*/
var checkFRMSubscription = function checkFrmSubscription(selectedLevel, exam_data, examPlanData) {
  var flag = false;
  const skipMock = Boolean(examPlanData);
  for (var i = 0; i < exam_data.length; i++) {
    if (
      exam_data[i].exam_name === arr[selectedLevel] ||
      exam_data[i].exam_name === "frm_1_2"
    ) {
      if (exam_data[i].levels.length) {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (skipMock && exam_data[i].levels[j].package_category === 'mock') continue;
          if (exam_data[i].levels[j].partner) {
            // inside if block to check the subscription for partner user plans
            if (exam_data[i].levels[j].isActive) {
              flag = true;
            }
          } else {
            // inside else block to check the subscription for partner user app plans
            if (exam_data[i].levels[j].isActive) {
              flag = true;
            }
          }
        }
      } else {
        flag = true; //for old user
      }
    } else {
      if (exam_data[i].levels.length) {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (
            exam_data[i].levels[j].package_val === "unlimited" &&
            (exam_data[i].levels[j].package_id === 16 ||
              exam_data[i].levels[j].package_id === 17 ||
              exam_data[i].levels[j].package_id === 18 ||
              exam_data[i].levels[j].package_id === 20 ||
              exam_data[i].levels[j].package_id === 22 ||
              exam_data[i].levels[j].package_id === 23 ||
              exam_data[i].levels[j].package_id === 24 ||
              exam_data[i].levels[j].package_id === 25)
          ) {
            flag = true;
          }
        }
      }
    }
  }
  return flag;
};

/*
---------------------------------------------
  FUNCTION TO CHECK SUBSCRIPTION FOR NOTES
---------------------------------------------
*/

var checkFrmNotesSubscription = function checkFrmNotesSubscription(
  selectedLevel,
  exam_data,
  examPlanData
) {
  var flag = false;
  const skipMock = Boolean(examPlanData);
  for (var i = 0; i < exam_data.length; i++) {
    if (
      exam_data[i].exam_name === arr[selectedLevel] ||
      exam_data[i].exam_name === "frm_1_2"
    ) {
      if (exam_data[i].levels.length) {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (skipMock && exam_data[i].levels[j].package_category === 'mock') continue;
          if (exam_data[i].levels[j].partner) {
            /*
            -----------------
             Partner User's
            ----------------
            */
            // inside if block check for the partner subscription plans
            if (
              exam_data[i].levels[j].package_val === "expensive" &&
              exam_data[i].levels[j].isActive
            ) {
              flag = true;
            } else if (
              exam_data[i].levels[j].package_val === "simple" &&
              exam_data[i].levels[j].isActive &&
              exam_data[i].levels[j].noteStatus !== false
            ) {
              // simple with extras add-ons
              flag = true;
              break;
            }
          } else {
            /*
            ----------------
              App User's
            ---------------
            */
            // inside else block check for the partner user app subcription plans
            if (
              exam_data[i].levels[j].package_val === "expensive" &&
              exam_data[i].levels[j].isActive // expensive plans
            ) {
              flag = true;
            } else if (
              exam_data[i].levels[j].package_val === "simple" &&
              exam_data[i].levels[j].isActive &&
              exam_data[i].levels[j].noteStatus !== false
              // simple with notes add-ons check
            ) {
              flag = true;
              break;
            } else if (
              exam_data[i].levels[j].package_val === "unlimited" &&
              exam_data[i].levels[j].isActive
            ) {
              flag = true;
            }
          }
        }
      } else {
        flag = true; //for old user
      }
    } else {
      // inside else check for the partner user app subscription other plans
      if (exam_data[i].levels.length) {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (
            exam_data[i].levels[j].package_val === "unlimited" &&
            (exam_data[i].levels[j].package_id === 16 ||
              exam_data[i].levels[j].package_id === 17 ||
              exam_data[i].levels[j].package_id === 18 ||
              exam_data[i].levels[j].package_id === 20 ||
              exam_data[i].levels[j].package_id === 22 ||
              exam_data[i].levels[j].package_id === 23 ||
              exam_data[i].levels[j].package_id === 24 ||
              exam_data[i].levels[j].package_id === 25)
          ) {
            flag = true;
          }
        }
      }
    }
  }
  return flag;
};

/*
---------------------------------------------
  FUNCTION TO CHECK SUBSCRIPTION FOR VIDEOS
---------------------------------------------
*/

var checkFrmVideosSubscription = function checkFrmVideosSubscription(
  selectedLevel,
  exam_data,
  examPlanData
) {
  var flag = false;
  const skipMock = Boolean(examPlanData);
  for (var i = 0; i < exam_data.length; i++) {
    if (
      exam_data[i].exam_name === arr[selectedLevel] ||
      exam_data[i].exam_name === "frm_1_2"
    ) {
      if (exam_data[i].levels.length) {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (skipMock && exam_data[i].levels[j].package_category === 'mock') continue;
          if (exam_data[i].levels[j].partner) {
            /*
            -------------------
              Partner  user's
            -------------------
            */
            if (
              exam_data[i].levels[j].package_val === "expensive" &&
              exam_data[i].levels[j].isActive &&
              exam_data[i].levels[j].videoStatus !== false
            ) {
              flag = true;
              // break;
            } else if (
              exam_data[i].levels[j].package_val === "simple" &&
              exam_data[i].levels[j].isActive &&
              exam_data[i].levels[j].videoStatus !== false
            ) {
              flag = true;
              // break;
            }
          } else {
            /*
            ---------------------
              Partner User's
            ---------------------
            */
            if (
              exam_data[i].levels[j].package_val === "expensive" &&
              exam_data[i].levels[j].isActive &&
              exam_data[i].levels[j].videoStatus !== false
            ) {
              flag = true;
              // break;
            } else if (
              exam_data[i].levels[j].package_val === "simple" &&
              exam_data[i].levels[j].isActive &&
              exam_data[i].levels[j].videoStatus !== false
            ) {
              flag = true;
              // break;
            } else if (
              exam_data[i].levels[j].package_val === "unlimited" &&
              exam_data[i].levels[j].isActive &&
              exam_data[i].levels[j].videoStatus !== false
            ) {
              flag = true;
              // break;/
            }
          }
        }
      } else {
        flag = true;
      }
      // break;
    } else {
      // inside else block check the partner user app subscription plans
      if (exam_data[i].levels.length) {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (
            exam_data[i].levels[j].package_val === "unlimited" &&
            exam_data[i].levels[j].videoStatus !== false &&
            (exam_data[i].levels[j].package_id === 16 ||
              exam_data[i].levels[j].package_id === 17 ||
              exam_data[i].levels[j].package_id === 18 ||
              exam_data[i].levels[j].package_id === 20 ||
              exam_data[i].levels[j].package_id === 22 ||
              exam_data[i].levels[j].package_id === 23 ||
              exam_data[i].levels[j].package_id === 24 ||
              exam_data[i].levels[j].package_id === 25)
          ) {
            flag = true;
          }
        }
      }
    }
  }
  return flag;
};

/*
--------------------------------------------
  FUNCTION TO CHECK SUBSCRIPTION FOR PDF'S
--------------------------------------------
*/

var checkFrmPDFSubscription = function checkFrmPDFSubscription(
  selectedLevel,
  exam_data,
  type,
  examPlanData,
) {
  var flag = false;
  const skipMock = Boolean(examPlanData);
  // mock entries always carry pdfstatus=false / noteStatus=false (DEFAULT_PACKAGE_DETAILS),
  // so gating expensive/unlimited on the matching flag filters them out.
  var requiredFlag = type === "notes" ? "noteStatus" : "pdfstatus";
  for (var i = 0; i < exam_data.length; i++) {
    if (
      exam_data[i].exam_name === arr[selectedLevel] ||
      exam_data[i].exam_name === "frm_1_2"
    ) {
      if (exam_data[i].levels.length) {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (skipMock && exam_data[i].levels[j].package_category === 'mock') continue;
          if (exam_data[i].levels[j].partner) {
            /*
            ------------------
              Partner User's
            ------------------
            */
            if (
              exam_data[i].levels[j].package_val === "expensive" &&
              exam_data[i].levels[j].isActive &&
              exam_data[i].levels[j][requiredFlag] !== false
            ) {
              flag = true;
            } else if (
              exam_data[i].levels[j].package_val === "simple" &&
              exam_data[i].levels[j].isActive // simple active plans
            ) {
              if (exam_data[i].levels[j].pdfstatus && type === "question") {
                flag = true;
              } else if (
                exam_data[i].levels[j].noteStatus &&
                type === "notes"
              ) {
                flag = true;
              }
            }
          } else {
            /*
            ---------------
              App User's
            ---------------
            */
            if (
              exam_data[i].levels[j].package_val === "expensive" &&
              exam_data[i].levels[j].isActive &&
              exam_data[i].levels[j][requiredFlag] !== false
            ) {
              flag = true;
            } else if (
              exam_data[i].levels[j].package_val === "simple" &&
              exam_data[i].levels[j].isActive
            ) {
              if (exam_data[i].levels[j].pdfstatus && type === "question") {
                flag = true;
              } else if (
                exam_data[i].levels[j].noteStatus &&
                type === "notes"
              ) {
                flag = true;
              }
            } else if (
              exam_data[i].levels[j].package_val === "unlimited" &&
              exam_data[i].levels[j].isActive &&
              exam_data[i].levels[j][requiredFlag] !== false
            ) {
              flag = true;
              // break;
            }
          }
        }
      } else {
        flag = true; //for old user
      }
      // break;
    } else {
      // Inside else block check for partner user app subscription plans
      if (exam_data[i].levels.length) {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (
            exam_data[i].levels[j].package_val === "unlimited" &&
            exam_data[i].levels[j][requiredFlag] !== false &&
            (exam_data[i].levels[j].package_id === 16 ||
              exam_data[i].levels[j].package_id === 17 ||
              exam_data[i].levels[j].package_id === 18 ||
              exam_data[i].levels[j].package_id === 20 ||
              exam_data[i].levels[j].package_id === 22 ||
              exam_data[i].levels[j].package_id === 23 ||
              exam_data[i].levels[j].package_id === 24 ||
              exam_data[i].levels[j].package_id === 25)
          ) {
            flag = true;
            // break;
          }
        }
      }
    }
  }
  return flag;
};

var checkFormulaSheetSubscription = function checkFormulaSheetSubscription(
  selectedLevel,
  exam_data,
  examPlanData,
) {
  var flag = false;
  const skipMock = Boolean(examPlanData);
  for (var i = 0; i < exam_data.length; i++) {
    if (
      exam_data[i].exam_name === arr[selectedLevel] ||
      exam_data[i].exam_name === 'frm_1_2'
    ) {
      if (exam_data[i].levels.length) {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (skipMock && exam_data[i].levels[j].package_category === 'mock') continue;
          /* -----------------
             Partner User's
            ----------------
            */
          if (exam_data[i].levels[j].partner) {
            if (
              (exam_data[i].levels[j].package_val === 'expensive' ||
                exam_data[i].levels[j].package_val === 'simple' ||
                exam_data[i].levels[j].package_val === 'unlimited') &&
              exam_data[i].levels[j].isActive
            ) {
              flag = true;
              // break;
            }
          } else {
            /*
            ----------------
              App User's
            ---------------
            */
            if (
              (exam_data[i].levels[j].package_val === 'expensive' ||
                exam_data[i].levels[j].package_val === 'simple' ||
                exam_data[i].levels[j].package_val === 'unlimited') &&
              exam_data[i].levels[j].isActive
            ) {
              flag = true;
              // break;
            }
          }
        }
      } else {
        flag = true; //for old user
      }
      // break;
    } else {
      // console.log("else");

      if (exam_data[i].levels.length) {
        // console.log("else length");

        for (var j = 0; j < exam_data[i].levels.length; j++) {
          // console.log("else for");

          if (
            exam_data[i].levels[j].package_val === 'unlimited' &&
            (exam_data[i].levels[j].package_id === 16 ||
              exam_data[i].levels[j].package_id === 17 ||
              exam_data[i].levels[j].package_id === 18 ||
              exam_data[i].levels[j].package_id === 20 ||
              exam_data[i].levels[j].package_id === 22 ||
              exam_data[i].levels[j].package_id === 23 ||
              exam_data[i].levels[j].package_id === 24 ||
              exam_data[i].levels[j].package_id === 25)
          ) {
            // console.log("lowewerrwork");

            flag = true;
            // break;
          }
        }
      }
    }
  }
  return flag;
};
exports.checkFrm = checkFRMSubscription;
exports.checkFrmNotesSubscription = checkFrmNotesSubscription;
exports.checkFrmVideosSubscription = checkFrmVideosSubscription;
exports.checkFrmPDFSubscription = checkFrmPDFSubscription;
exports.checkFormulaSheetSubscription = checkFormulaSheetSubscription;



// WEBPACK FOOTER //
// ./src/views/RestAPI/PartnerSubscription/FrmSubscription.js